var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "distribution-work-bench" }, [
    _c("div", { staticClass: "work-top" }, [
      _c(
        "div",
        { staticClass: "work-bench-left-top" },
        [
          _c(
            "div",
            { staticClass: "filter-area" },
            [
              _c(
                "Select",
                {
                  model: {
                    value: _vm.selectValue,
                    callback: function ($$v) {
                      _vm.selectValue = $$v
                    },
                    expression: "selectValue",
                  },
                },
                _vm._l(_vm.option, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("sale-list", { attrs: { saleListConfig: _vm.saleListConfig } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-right-top" },
        [_c("info-list", { attrs: { info: _vm.saleInfo } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "work-bottom" }, [
      _c(
        "div",
        { staticClass: "work-bench-left-bottom" },
        [
          _c("define-echart", {
            staticClass: "barContainer",
            attrs: { id: "barContainer", option: _vm.barOption },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tablewrap" },
            [
              _c("stor-table", {
                attrs: { sortTableConfig: _vm.sortTableConfig },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-right-bottom" },
        [_c("info-list", { attrs: { info: _vm.publicInfo } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }